import type { CSSProperties } from 'react';
import { getStrings, type Lang } from '../lib/i18n';
import { StoreBadges } from './StoreBadges';
import { STORE_IOS, STORE_ANDROID } from '../lib/constants';

type Vars = CSSProperties & Record<`--${string}`, string | number>;

export const Download = ({ lang = 'en' as Lang }: { lang?: Lang }) => {
  const t = getStrings(lang);
  const s = t.store;
  return (
    <section id="download" className="py-20 md:py-28">
      <div className="container mx-auto px-5 sm:px-6">
        <div data-reveal="pop" className="max-w-4xl mx-auto">
          <div className="card-glow px-6 py-14 md:px-12 md:py-20 text-center" style={{ '--glow': 'var(--brand-2)' } as Vars}>
            {/* Bobbing stickers */}
            <div className="absolute left-6 top-6 md:left-10 md:top-10 hidden sm:block" aria-hidden="true">
              <div className="bob" style={{ '--r': '-10deg' } as Vars}>
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 text-3xl">💪</span>
              </div>
            </div>
            <div className="absolute right-6 bottom-6 md:right-10 md:bottom-10 hidden sm:block" aria-hidden="true">
              <div className="bob" style={{ '--i': 2, '--r': '8deg' } as Vars}>
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 text-3xl">🏆</span>
              </div>
            </div>

            <h2 className="font-heading text-4xl md:text-5xl font-black text-white tracking-tight mb-9 max-w-2xl mx-auto">
              {t.download.heading}
            </h2>

            <div className="flex flex-row flex-wrap items-center justify-center gap-3 mb-6">
              <StoreBadges iosHref={STORE_IOS} androidHref={STORE_ANDROID} s={s} lang={lang} />
            </div>

            <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm font-bold text-white/85">
              <span className="h-2 w-2 rounded-full bg-[#58cc02]" aria-hidden="true" />
              {t.download.free}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
